import React, { useState, useEffect, useContext } from 'react'
import emailListContext from '../../../context/context'
import PropTypes from 'prop-types'
import { getPayloadFunction } from '../../Utility'
import { useKeycloak } from '@react-keycloak/web'
import { useHistory } from 'react-router-dom'
import * as emailListService from '../../../Services'
import APIInterceptor from '../../../../../apis/APIInterceptors'
import emailListAPIs from '../../../../../apis/emailList'
// import { AssignmentReturnedSharp } from '@material-ui/icons'

const SaveEmailList = props => {
    const history = useHistory()
    const { keycloak } = useKeycloak()
    const paramId = (new URLSearchParams(window.location.search)).get('Id')
    const { listType, emailList, setEmailList, searchFields, setSnackBar } = useContext(emailListContext)
    const [saveClicked, setSaveClicked] = useState(false)

    useEffect(() => {
        if (saveClicked) {
            handleSave()
        }
    }, [saveClicked])

    const isdisabled = () => {
        let returnVal = false
        // console.log('emailList::', emailList)
        if (emailList && emailList.recordStatus === 'Published') {
            returnVal = true
        }

        return returnVal
    }

    const handleSave = async () => {

        let countThreshold = 30000
        const payloadFunction = getPayloadFunction(listType)
        let criteriaPayload = payloadFunction(searchFields)
        let recordStatus = 'Saved'
        let isBulkUpload = emailList.polarisEmailListId && emailList.listType.toLowerCase().includes('bulk') ? true : false
        // console.log('isBulkUpload::', isBulkUpload)
        try {
            if (Object.keys(criteriaPayload).length === 0 && !isBulkUpload) {
                setSaveClicked(false)
                setSnackBar({ type: 'error', message: 'Contacts are required to save the list. Please search for contacts.', show: true })
                return
            }

            if (!emailList.listName) {
                setSaveClicked(false)
                setSnackBar({ type: 'error', message: 'List name is required. Please add a name for the list.', show: true })
                return
            }
            // this.setState({ isLoading: true })

            let criteriaInFilter = Object.keys(criteriaPayload)

            let criteriaToSaveList = ['excludeBrokers', 'excludeClientPref', 'mergeLists', 'subjectPropertyCriteria']
            let isDirectSave = criteriaInFilter.some(val => criteriaToSaveList.indexOf(val) !== -1)
            let uniqueSummaryCount = countThreshold + 1
            isDirectSave = isBulkUpload ? isBulkUpload : isDirectSave
            criteriaPayload.polarisEmailListId = emailList.polarisEmailListId

            if (!isDirectSave) {
                const headersForSummarydata = { 'Content-Type': 'application/x-www-form-urlencoded', }
                const getCountRslt = await APIInterceptor(emailListAPIs.getSummaryCount, criteriaPayload, headersForSummarydata)
                uniqueSummaryCount = getCountRslt.data.uniqueSummaryCount
            }

            if (isDirectSave || uniqueSummaryCount > countThreshold) {
                recordStatus = 'Inprogress'
            }

            let polarisEmailListId = (new URLSearchParams(window.location.search)).get('Id')
            // const paramName = (new URLSearchParams(window.location.search)).get('Name')
            let sfUserId = (new URLSearchParams(window.location.search)).get('userid')
            sfUserId = sfUserId === 'null' || !sfUserId ? '' : sfUserId

            var totalnumber = 0

            let payload = {
                polarisEmailListId: emailList.polarisEmailListId ? emailList.polarisEmailListId : '',
                listName: emailList.listName,
                // polarisUserId: keycloak.subject,
                // polarisUserName: `${keycloak.tokenParsed.given_name} ${keycloak.tokenParsed.family_name}`,
                polarisUserId: emailList.polarisEmailListId ? emailList.polarisUserId : keycloak.subject,
                polarisUserName: emailList.polarisEmailListId ? emailList.polarisUserName : `${keycloak.tokenParsed.given_name} ${keycloak.tokenParsed.family_name}`,
                createdDate: emailList.polarisEmailListId ? emailList.createdDate : new Date(),
                omniViewUserId: emailList.polarisEmailListId ? emailList.omniViewUserId : sfUserId,
                addedContacts: searchFields.addedContacts,
                emailListActionType: searchFields.addedContacts.length === 0 && searchFields.deletedContacts.length > 0 ? 'Delete' : 'Add',
                deletedContacts: searchFields.deletedContacts,
                // subjectPropertyCriteria: searchFields.SubjectProperty,
                oldMergedLists: emailList.polarisEmailListId && emailList.oldMergedLists ? emailList.oldMergedLists : [],
                mergeLists: searchFields.SelectedLists,
                recordStatus: recordStatus,
                listType: emailList.polarisEmailListId ? emailList.listType : 'property',
            }

            Object.keys(criteriaPayload).forEach(item => {
                payload[item] = criteriaPayload[item]
            })

            if (!emailList.polarisEmailListId) {
                delete payload.polarisEmailListId
            }

            // console.log('emailList::', emailList)
            // console.log('payload::', JSON.stringify(payload))
            // return
            const response = await emailListService.saveEmailList(payload)
            setSnackBar({ type: 'success', message: `List ${emailList.polarisEmailListId ? 'updated' : 'Saved'}`, show: true })
            setSaveClicked(false)

            if (recordStatus === 'Inprogress') {

                alert('The applied criteria takes a while. Please keep visiting dashboard to check the list status.')

                let queryParam = "?userid=" + sfUserId
                history.push({
                    pathname: '/EmailListInitialPage',
                    search: queryParam
                })
                return
            }

            // console.log('saveEmailList response::', response)
            if (response.status === 200) {
                setEmailList(response.data)
                polarisEmailListId = response.data.polarisEmailListId

                const pathName = (window.location.href).includes('EmailListDetails') ? '/EmailListDetails' : '/EmailLists'
                history.push({
                    pathname: pathName,
                    search: "?" + new URLSearchParams({ listType: 'property', Id: polarisEmailListId, Name: emailList.listName, total: totalnumber, userid: sfUserId }).toString()
                })

            } else {
                setSaveClicked(false)
                setSnackBar({ type: 'error', message: 'Unable to update the list ', show: true })
            }

        } catch (err) {
            setSaveClicked(false)
            console.log('unable to save the list:::', err)
        }

    }

    return (
        <>
            {saveClicked ?
                <button className={`${props.className} c-disabled`} >
                    <span className="loader h-5 w-5 mx-2" ></span>
                    <span className="px-2">{paramId ? 'Update' : 'Save'}</span>
                </button>
                :
                <button data-testid="TopMenu_btnSave_test" disabled={isdisabled()} className={`${props.className} ${isdisabled() ? 'text-black' : ''}`} onClick={() => { setSaveClicked(true) }}>
                    {paramId ? 'Update' : 'Save'}
                </button>
            }

        </>
    )
}

SaveEmailList.propTypes = {
    className: PropTypes.string
}

export default SaveEmailList
